import {
  addonOptionsSchema,
  type CustomerOrder,
  scriptOptionsSchema,
  titleOptionsSchema,
} from '@noconflict/contracts';
import type { TFunction } from 'i18next';

/**
 * One line saying what an order is for, e.g. "Title clearance report: Worldwide, 1 business day". An add-on is
 * its pack ("10 additional clearances"), and options that fit nothing give the product name alone.
 */
export function orderSummary(
  t: TFunction<'order'>,
  order: Pick<CustomerOrder, 'product' | 'options'>,
): string {
  const product = t(`products.${order.product}`);
  if (order.product === 'title') {
    const o = titleOptionsSchema.safeParse(order.options).data;
    if (o)
      return t('summary.title', {
        product,
        scope: t(`scope.${o.scope}`),
        turnaround: t('turnaround', { count: o.turnaroundDays }),
      });
  } else if (order.product === 'script') {
    const o = scriptOptionsSchema.safeParse(order.options).data;
    if (o)
      return t('summary.script', {
        product,
        length: t(`length.${o.length}`),
        turnaround: t('turnaround', { count: o.turnaroundDays }),
      });
  } else if (order.product === 'script_additional_clearances') {
    const o = addonOptionsSchema(order.product).safeParse(order.options).data;
    if (o) return t('script.form.clearanceTitle', { count: o.quantity });
  } else if (order.product === 'script_versions') {
    const o = addonOptionsSchema(order.product).safeParse(order.options).data;
    if (o) return t('script.form.revisionTitle', { count: o.quantity });
  }
  return product;
}
